<template>
  <VueResizable class="catalog-tree" :active="['r']" width="346px" height="100%">
    <div class="tip"><span>文档管理</span>
    <el-tooltip class="tip-item" effect="dark" content="新建文件夹" placement="bottom" @click.native="check">
      <i class="icon iconfont iconicon_new_folder tableIconHover"></i>
    </el-tooltip>
    </div>
    <TreeElement :active="active" :listData="listData" :level="1"></TreeElement>
    <FileDialog v-model="fileDialogShow" :pid="pid" @success="addSuccess" @update="update" :dataset="dataset" :isEdit="isEdit"></FileDialog>
  </VueResizable>
</template>
<script>
import TreeElement from './element'
import FileDialog from './fileDialog'
import bus from '@/bus'
import api from '@/services/api/help/help'
import VueResizable from 'vue-resizable'
export default {
  components: {
    TreeElement,
    FileDialog,
    VueResizable
  },
  data() {
    return {
      fileDialogShow: false,
      pid: '',
      active: '',
      dataset: {},
      listData: [],
      isEdit: false
    }
  },
  created() {
    // 新建文件或文档弹窗， pid为新建文档
    bus.$on('checkDocument', (pid) => {
      this.pid = Number(pid || 0)
      this.isEdit = false
      this.dataset = {}
      this.fileDialogShow = true
    })
    // 选中的节点
    bus.$on('treeSelectElement', res => {
      this.active = res.id
    })
    // 编辑节点
    bus.$on('editDocument', res => {
      this.pid = Number(res.pid || 0)
      this.dataset = res
      this.isEdit = true
      this.fileDialogShow = true
    })
    // 删除节点
    bus.$on('delDocument', res => {
      if(Number(res.pid) === 0) {
        let idx = this.listData.findIndex(temp => Number(temp.id) === Number(res.id))
        this.listData.splice(idx, 1)
      } else {
        let arr = this.findNodeById(this.listData, Number(res.pid))
        let idx = arr.children.findIndex(temp => Number(temp.id) === Number(res.id))
        arr.children.splice(idx, 1)
      }
    })
    // 更新节点
    bus.$on('treeElementUpdate', res => {
      this.update(res)
    })
    this.init()
  },
  destroyed() {
    bus.$off('checkDocument')
  },
  methods: {
    async init() {
      this.loading = true
      let result =  await api.documentDraftsIndex({per_page: 999, page: 1, pid: this.pid, level: 2})
      if(!this.pid) {
        result.data.map(res => {
          res.open = true
        })
      }
      this.listData = result.data
      this.loading = false
    },
    check() {
      this.pid = ''
      this.isEdit = false
      this.fileDialogShow = true
    },
    addSuccess(res) {
      res.open = true
      if(Number(res.pid) === 0) {
        this.listData.unshift(res)
      } else {
        let temp = this.findNodeById(this.listData, Number(res.pid))
        console.log(temp)
        if(!temp.children) {
          this.$set(temp, 'children', [])
        }
        temp.children.unshift(res)
      }
    },
    update(res) {
      if(Number(res.pid) === 0) {
        let idx = this.listData.findIndex(temp => Number(temp.id) === Number(res.id))
        let result = Object.assign({}, this.listData[idx], res)
        this.listData.splice(idx, 1, result)
      } else {
        let arr = this.findNodeById(this.listData, res.pid)
        let idx = arr.children.findIndex(temp => Number(temp.id) === Number(res.id))
        let result = Object.assign({}, arr.children[idx], res)
        arr.children.splice(idx, 1, result)
      }
      if(Number(res.id) === this.active) {
        bus.$emit('treeSelectElement', res)
      }
    },
  }
}
</script>
<style lang="scss">
.catalog-tree {
  padding: 0 24px;
  box-sizing: border-box;
  border-right: 1px solid rgba(32, 32, 32, 0.08);
  height: 100% !important;
  overflow-x: hidden;
  overflow-y: overlay;
  flex-shrink: 0;
  position: relative;
  background-color: #fff;
  position: relative;
  z-index: 3;
  &>.tip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 42px;
    color: rgba(32, 32, 32, 0.6);
    font-size: 14px;
    .tip-item {
      display: none;
    }
    &:hover {
      .tip-item {
        display: block;
      }
    }
  }
}
</style>
